// https://developer.spotify.com/documentation/web-playback-sdk/quick-start/#
export const authEndpoint = "https://accounts.spotify.com/authorize";
// Replace with your app's client ID, redirect URI and desired scopes


// *LOAD BALANCING NEU *
// BEI SABRYNA NEU https://developer.spotify.com/dashboard/applications/1668db4054d24ede8b1c1b0b2b3f3ba0
// BEI HANSI NEU: https://developer.spotify.com/dashboard/applications/ae00f23aec314de4910061d27117c2b5





// CLIENT SPOT DEV DASHBOARD

// TEST  
// (ohne fabi, localhost geht bei beiden)
                                      //SABBY                              //hansi
const auswahlClientId = ["f1bf78af288844bab87f9972febb394f","ae00f23aec314de4910061d27117c2b5"];


// LIVE  !Fabi noch Dev Mode!
// (mit fabi, fabi localhost geht nicht, weil redirect uri nicht stimmt)
                                      //SABBY                              //hansi                   // fabi
  // const auswahlClientId = ["f1bf78af288844bab87f9972febb394f","ae00f23aec314de4910061d27117c2b5", "1fc0f0908cf64f8fa70ba3220d114d33"];

let IndexForClientId = Math.floor(Math.random()*auswahlClientId.length);

// Export the selected client ID for token exchange
export const getClientId = () => auswahlClientId[IndexForClientId];





// const clientSecret = "e9e32caa0b5d409a933d6ddec723081a"; braucht es nicht bei dieser methode

// const redirectUri = "https://spot-feedback-carousel.web.app/";

const redirectUri = "https://songcarousel.com/";
 //const redirectUri = "http://localhost:3000/";



const scopes = [


  // -- CHECK WHAT IS NEEDED 26.10 ---

  // ---- VERSION MIT WEB PLAYBACK -- START ---

  
    // Für WEBPLAYBACK - other song error
//"user-read-currently-playing",

    // Für WEBPLAYBACK - Play - und pause error
"streaming",

    // Required by the Web Playback SDK (desktop playback in the browser)
"user-read-email",
"user-read-private",

      // ---- VERSION MIT WEB PLAYBACK -- ENDE ---


  // ---- VERSION WITH APP PLAYBACK -- START ---



// Für Initial connection, Error Pause und error different song
"user-read-playback-state",

  // Um Song zu starten des Carousels nach connect
"user-modify-playback-state",


    // ---- VERSION WITH APP PLAYBACK -- ENDE ---

   // DOCH NICHT BENÖTIGT
     // BENÖTIGT FÜR SUCHE + WDK PLAYEER SIEHE https://github.com/gilbarbara/react-spotify-web-playback
  //"user-read-private",
  // "user-modify-playback-state",

  //"user-read-playback-state",

// - - - - experiment
// "user-read-recently-played",
    // "user-top-read",
  // "playlist-read-private",
  // "playlist-read-collaborative",

  //26.10. "user-library-read",

  // used for add to favorites:

// "user-library-modify",


 

  //nicht mehr seit umstellung auf firebase auth 
 // "user-read-email",
  





 



];

// Store token in localStorage for persistent login
export const storeToken = (token) => {
  if (token) {
    localStorage.setItem('spotify_access_token', token);
    // Store timestamp for token expiration (Spotify tokens expire after 1 hour)
    const expiresIn = 3600000; // 1 hour in milliseconds
    const expiresAt = Date.now() + expiresIn;
    localStorage.setItem('spotify_token_expires_at', expiresAt.toString());
  }
};

// Get stored token if still valid
export const getStoredToken = () => {
  const token = localStorage.getItem('spotify_access_token');
  const expiresAt = localStorage.getItem('spotify_token_expires_at');

  if (!token || !expiresAt) {
    return null;
  }

  // Check if token has expired
  if (Date.now() >= parseInt(expiresAt, 10)) {
    // Token expired, clear storage
    localStorage.removeItem('spotify_access_token');
    localStorage.removeItem('spotify_token_expires_at');
    return null;
  }

  return token;
};

// Clear stored token (for logout)
export const clearStoredToken = () => {
  localStorage.removeItem('spotify_access_token');
  localStorage.removeItem('spotify_token_expires_at');
};

// ==============================
// PKCE HELPER FUNCTIONS
// ==============================

// Generate a random code verifier (43-128 characters)
const generateCodeVerifier = () => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return base64URLEncode(array);
};

// Base64 URL encode
const base64URLEncode = (buffer) => {
  return btoa(String.fromCharCode.apply(null, buffer))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

// Generate code challenge from verifier
const generateCodeChallenge = async (verifier) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64URLEncode(new Uint8Array(digest));
};

// Store PKCE verifier for later use
export const storeCodeVerifier = (verifier) => {
  sessionStorage.setItem('spotify_code_verifier', verifier);
};

// Get stored code verifier
export const getCodeVerifier = () => {
  return sessionStorage.getItem('spotify_code_verifier');
};

// Clear code verifier
export const clearCodeVerifier = () => {
  sessionStorage.removeItem('spotify_code_verifier');
};

// ==============================
// OAUTH FLOW FUNCTIONS
// ==============================

export const getTokenFromResponse = () => {
  return window.location.hash
    .substring(1)
    .split("&")
    .reduce((initial, item) => {
      var parts = item.split("=");
      initial[parts[0]] = decodeURIComponent(parts[1]);

      return initial;
    }, {});
};

// Get authorization code from URL (new PKCE flow)
export const getCodeFromResponse = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('code');
};

// Generate the authorization URL with PKCE
export const generateAuthUrl = async () => {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);

  // Store verifier for later token exchange
  storeCodeVerifier(codeVerifier);

  const state = generateRandomString(16);
  sessionStorage.setItem('spotify_auth_state', state);

  return `${authEndpoint}?client_id=${auswahlClientId[IndexForClientId]}&redirect_uri=${redirectUri}&scope=${scopes.join(
    "%20"
  )}&response_type=code&show_dialog=true&code_challenge_method=S256&code_challenge=${codeChallenge}&state=${state}`;
};

// Generate random string for state parameter
const generateRandomString = (length) => {
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const values = crypto.getRandomValues(new Uint8Array(length));
  return values.reduce((acc, x) => acc + possible[x % possible.length], "");
};

// Legacy implicit flow URL (DEPRECATED - kept for reference)
export const accessUrl = `${authEndpoint}?client_id=${auswahlClientId[IndexForClientId]}&redirect_uri=${redirectUri}&scope=${scopes.join(
  "%20"
)}&response_type=token&show_dialog=true`;


 